import React from 'react';
import { Modal } from '@consta/uikit/Modal';
import AuthModal from 'src/components/AuthModal/AuthModal';

const Authorization: React.FC = () => {
  return (
    <div>
      <Modal isOpen={true}>
        <AuthModal />
      </Modal>
    </div>
  );
};

export default Authorization;
